<template>
  <div id="diagnosticsForm">
    <div class="mb-4">
      <h1 class="mb-4">Condiciones de salud</h1>
      <div class="col-md-6">
        <SelectSearch
          placeholder="Seleccionar Empleado"
          name="name"
          label="Empleado"
          :options="employess"
          :loading="loading"
          :disabled="false"
          :value="employee"
          @input="(value) => selectedEmployee(value)"
          @search="(value) => searchEmployee(value)"
        />
      </div>
    </div>

    <template v-if="employee">
      <div class="row mb-5">
        <div class="col-md-12">
          <InformationEmployee :employee="employee" />
        </div>
      </div>

      <b-row class="mt-5 mb-5">
        <b-col cols="auto" class="mr-auto">
          <strong>Examenes Médicos Generales de Planta</strong>
        </b-col>
        <b-col cols="auto">
          <button class="button-primary" @click.prevent="newExamen()">
            <span
              >Agregar nuevo examén
              <img class="pl-1 mb-1" src="@/assets/images/icons/add.svg"
            /></span>
          </button>
        </b-col>
      </b-row>

      <b-row class="mt-5 mb-5">
        <b-col cols="12"> <TableExam /> </b-col>
      </b-row>

      <!-- Encuesta de morbilidad sentida -->
      <div>
        <b-row class="mt-5 mb-5">
          <b-col cols="auto" class="mr-auto">
            <strong>Encuestas de Morbilidad Sentida</strong>
          </b-col>
          <b-col cols="auto">
            <button class="button-primary" @click.prevent="newEncuesta()">
              <span
                >Agregar nueva encuesta
                <img class="pl-1 mb-1" src="@/assets/images/icons/add.svg"
              /></span>
            </button>
          </b-col>
        </b-row>
        <b-row class="mt-5 mb-5">
          <b-col cols="12"> <TableMorbidity /> </b-col>
        </b-row>
      </div>
    </template>

    <template v-else>
      <b-col cols="12" sm="6" class="mt-5 text-center">
        <img
          class="centerImg1"
          src="@/assets/modules/health-tracker/img/pill.svg"
          width="50%"
          alt="logo"
        />
      </b-col>
    </template>

    
  </div>
</template>

<script>
import { getEmployees } from "@/services/health-tracker/matrizIper/service";
import {
  getEmployee,
} from "@/services/health-tracker/saludCondition/service";
import SelectSearch from "../matrizIper/components/SelectSearch.vue";
import InformationEmployee from "../matrizIper/components/InformationEmployee.vue";
import TableExam from "./components/tables/TableExam.vue";
import TableMorbidity from "./components/tables/TableMorbidity.vue";

export default {
  components: {
    InformationEmployee,
    SelectSearch,
    TableExam,
    TableMorbidity,
  },
  data: () => ({
    employess: [],
    loading: false,
    search: "",
    abortController: null,
    employee: null,
    idEmploployee: null,
  }),
  methods: {
    selectedEmployee(value) {
      const me = this;
      me.employee = value;
      me.$router.push({
        name: "sve",
        params: {
          category: "salud-condition",
          type: me.employee?.id ? me.employee?.id : null,
        },
      });
    },
    async loadEmployess() {
      const me = this;
      me.loading = true;
      me.employess = [];
      if (me.abortController) {
        me.abortController.abort(); // Cancela la petición anterior
      }

      me.abortController = new AbortController();
      const signal = me.abortController.signal;
      try {
        const { result } = await getEmployees(
          {
            search: me.search,
          },
          signal
        );
        me.employess = result;
      } catch (error) {
        console.log(error);
      } finally {
        me.loading = false;
      }
    },
    searchEmployee(value) {
      const me = this;
      me.search = value;
      me.loadEmployess();
    },
    async loadEmployee(id) {
      const me = this;
      try {
        const { data } = await getEmployee(id);
        me.employee = data;
      } catch (error) {
        console.log(error);
      }
    },
    newExamen() {
      const me = this;
      me.$router.push({
        name: "ExamenPage",
        params: { category: "salud-condition", type: me.employee?.id },
      });
    },
    newEncuesta() {
      const me = this;
      me.$router.push({
        name: "MorbidityPage",
        params: { category: "salud-condition", type: me.employee?.id },
      });
    },
  },
  async mounted() {
    const me = this;
    await me.loadEmployess();
    if (me.$route.params.type) {
      me.idEmploployee = me.$route.params.type;
      me.loadEmployee(me.idEmploployee);
    }
  },
};
</script>

<style lang="scss" />
